import { handleSmoothScroll } from '../../utils/scroll';
import './HeroSection.css';

const HeroSection = () => {
  return (
    <section className="portada">
      <div className='container'>
        <div className="row d-flex justify-content-center align-items-center">
          <div className="info-portada">
            <h1>
              INVITACIONES DIGITALES <br />
              DE BODA
            </h1>
            <p>
              Es momento de anunciar tu casamiento, hacelo de 
              <br />
              la forma más original, práctica y atractiva.
              <br />
              ¡Conocé nuestros modelos!
            </p>

            <a
              href="#invitaciones"
              className="boton smoth-scroll"
              onClick={(e) => handleSmoothScroll(e, '#invitaciones')}
            >
              Ver invitaciones
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
